import * as React from "react";

function SvgUnstableDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 12h-4L8 4l-3 8H1" stroke="#DA5858" /></svg>;
}

export default SvgUnstableDemand;